<template>
  <div class="subscription-advertising" v-if="plan.id">
    <div class="row align-items-center">
      <div class="col-md-7">
        <h2 class="mb-3">Assista a qualquer curso, quando e onde quiser</h2>

        <CheckList class="mb-4">
          <li class="check-light">
            <span>Cursos <strong>exclusivos</strong> CyberClass.</span>
          </li>
          <li class="check-light">
            <span>Especialista com <strong>experiências reais</strong>.</span>
          </li>
          <li class="check-light">
            <span><strong>Chat interativo</strong> para dúvidas.</span>
          </li>
          <li class="check-light">
            <span>Conteúdo sempre <strong>atual e atualizado</strong>.</span>
          </li>
        </CheckList>

        <div class="trial-box mb-4 mb-md-0 align-items-center">
          <picture>
            <img src="@/assets/img/subscription-ads/days-trial.png" alt="CyberClass - Período de teste grátis" />
          </picture>

          <div class="trial-text">
            <h3 class="title">Teste por 7 dias</h3>
            <p class="text">e se você não estiver satisfeito, nós <strong>devolvemos seu dinheiro</strong>.</p>
          </div>
        </div>
      </div>

      <div class="col-md-5">
        <div class="price-box mb-4 text-md-left text-center justify-content-md-start justify-content-center">
          <div class="old-price text-center text-md-left">
            De <strong>{{ plan.old_amount | toCurrency }}</strong>
          </div>

          <div class="installments">Por até {{ plan.max_installments }}x de</div>

          <span class="currency">R$</span>
          <span class="amount">{{ planMaxInstallmentInteger }}</span>
          <span class="decimal"><i class="separator">,</i> <span>{{ planMaxInstallmentDecimal }}</span></span>

          <div class="installments">Acesso total por 1 ano</div>
        </div>

        <PrimaryButton
          :full="true"
          @click="$router.push({name: 'subscribe'})"
        >Quero agora!</PrimaryButton>
      </div>
    </div>
  </div>
</template>

<script>
  import { getPlanDefault } from '@/api/plan.api'
  import CheckList from '@/components/layout/CheckList'
  import PrimaryButton from '@/components/buttons/PrimaryButton'

  export default {
    components: {
      CheckList,
      PrimaryButton,
    },

    data: () => ({
      plan: {}
    }),

    mounted () {
      this.fetchPlan()
    },

    computed: {
      planMaxInstallmentInteger () {
        return this.plan.max_installment_amount.toString().split('.')[0]
      },

      planMaxInstallmentDecimal () {
        return this.plan.max_installment_amount.toFixed(2).toString().split('.')[1]
      }
    },

    methods: {
      async fetchPlan () {
        this.plan = await getPlanDefault()
      },

    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .subscription-advertising {
    padding: 2.5rem;
    background-color: #000;
    border-radius: 10px;
    color: #fff;

    .trial-box {
      display: flex;

      picture {
        max-width: 150px;
        padding-right: 15px;

        img {
          width: auto;
          max-width: 100%;
        }
      }

      .title {
        color: $highlightPrimaryColor;
        font-weight: 600;
        font-size: 1.25rem;
      }
    }

    .price-box {
      display: inline-flex;
      align-items: flex-end;
      flex-wrap: wrap;
      font-weight: 600;

      .old-price {
        width: 100%;
        font-weight: 300;
        color: rgba(#fff, .3);
        font-size: 20px;
        margin-bottom: 5px;

        strong {
          text-decoration: line-through;
        }
      }

      .installments {
        width: 100%;
        margin-bottom: 8px;
      }

      .currency {
        font-size: 20px;
        font-weight: 500;
      }

      .amount {
        font-size: 80px;
        line-height: 60px;
        letter-spacing: -6px;
      }

      .decimal {
        align-self: flex-start;
        font-size: 30px;
        list-height: 30px;
        font-weight: 500;
        letter-spacing: -2px;
        margin-top: -10px;
        margin-left: 5px;

        .separator {
          font-size: 30px;
          font-weight: 600;
          font-family: 'Areal';
        }
      }
    }

    h2 {
      font-size: 1.625rem;
      font-weight: 600;
    }

    li {
      font-size: 1rem;

      &:not(:last-child) {
        border-bottom: 0 !important;
        margin: 0 !important;
        padding: 3px;
      }
    }
  }
</style>